module.exports = __webpack_public_path__ + "img/create-wallet-m-1.e512d1fb.png";